import { createContext } from "react";
import {
  ChatType,
  ChatNotificationsMuteOptions,
  NotificationCategory,
  SoundSupportedModule,
} from "@jugl-web/rest-api";

export type InAppNotification = {
  entityId: string;
  key?: string;
  title: string;
  module?: keyof NotificationCategory;
  senderId?: string;
  body?: string;
  clearBody?: string;
  onClick?: () => void;
};

export type TriggerNotificationParams = {
  body?: string;
  tag?: string;
  module?: SoundSupportedModule;
  onClick?: () => void;
};

export interface NotificationsContextValue {
  triggerInAppNotification: (notification: InAppNotification) => void;

  getChatNotificationsPreferences: (
    chatId: string
  ) => ChatNotificationsMuteOptions;
  setChatNotificationsPreferences: (
    chatId: string,
    chatType: ChatType,
    option: ChatNotificationsMuteOptions
  ) => void;

  notificationPreferences: NotificationCategory | undefined;
}

export const NotificationsContext =
  createContext<NotificationsContextValue | null>(null);
